import { GetStaticPaths, GetStaticProps } from 'next';
import cms from '../lib/contentful';
import DefaultPage, { Props } from '../src/DefaultPage';

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = await cms.getStaticPaths();

  return {
    paths: paths.map((path) => (
      { params: { slug: path.slug.slice(1).split('/') } }
    )),
    fallback: false,
  };
};

type Context = {
  params: {
    slug: string[]
  }
  preview: boolean
}

export const getStaticProps: GetStaticProps<Props> = async ({ params }) => {
  const { slug } = (params as Context['params']);
  const joinedSlug = slug.join('/');

  const pageData = await cms.getPageBySlug(joinedSlug);
  const navbarData = await cms.getNavbar();

  return {
    props: {
      isIndex: false,
      pageData: pageData.page,
      navbarData: navbarData.menu,
    },
  };
};

export default DefaultPage;
